
























import { Russian } from 'flatpickr/dist/l10n/ru'
import Vue from 'vue'
import { Component, Prop, VModel, Ref } from 'vue-property-decorator'

import DatePicker from '../DatePicker/DatePicker.vue'
import { PickerInputMode } from '../Picker/types'

enum DateSeparator {
  Range = ' - ',
  Multiple = ', '
}

@Component({
  components: {
    DatePicker,
  },
})
export default class InlinePicker extends Vue {
  @VModel() model!: Array<string> | string

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop({ type: Object }) readonly config!: { [key: string]: any }

  @Ref('date-picker') readonly datePicker!: any

  get configValue(): { [key: string]: any } {
    let config: { [key: string]: any } = {
      inline: true,
      conjunction: DateSeparator.Multiple,
      locale: { ...this.locale, ...{ rangeSeparator: ' - ' } },
    }

    if (this.config) {
      config = { ...config, ...this.config }
    }

    return config
  }

  get modelValue(): string {
    return this.mode === PickerInputMode.Single ? this.model as string : (this.model as Array<string>).join(this.dateSeparator)
  }

  set modelValue(value: string | null) {
    if (value !== null) {
      this.model = this.mode === PickerInputMode.Single ? value : (value as string).split(this.dateSeparator)
    } else {
      this.model = this.mode === PickerInputMode.Single ? '' : []
    }
  }

  get mode(): string {
    return this.configValue.mode || 'single'
  }

  get dateSeparator(): DateSeparator | string {
    if (this.mode === PickerInputMode.Range) {
      return DateSeparator.Range
    }
    if (this.mode === PickerInputMode.Multiply) {
      return DateSeparator.Multiple
    }
    return ''
  }

  // eslint-disable-next-line consistent-return,getter-return
  get locale(): any {
    if (this.$i18n.locale === 'ru') {
      return Russian
    }
    return {}
  }

  clear(): void {
    if (Array.isArray(this.model)) {
      this.model = []
    }

    if (typeof this.model === 'string') {
      this.model = ''
    }
  }

  created(): void {
    this.$i18n.mergeLocaleMessage('ru', {
      inline_picker_button_reset: 'Сбросить календарь',
    })
    this.$i18n.mergeLocaleMessage('en', {
      inline_picker_button_reset: 'Reset calendar',
    })
  }
}
